import { render, staticRenderFns } from "./ComboTipoAtendimento.vue?vue&type=template&id=91f76b68"
import script from "./ComboTipoAtendimento.vue?vue&type=script&lang=ts"
export * from "./ComboTipoAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports